import { makeObservable } from 'mobx'

import SharedStore from 'shared/stores/shared.store'
import { ShopRootStore } from 'shop/stores/shopRoot.store'
import { apiClient } from 'utils/requests.utils'
import { CourseThemesApi, createCourseThemesApi } from 'shop/api/courseThemes.api'

export class CourseThemesStore extends SharedStore<any> {
  storeName = 'CourseThemesStore'
  declare childApi: CourseThemesApi

  constructor(root: ShopRootStore) {
    super()
    this.childApi = createCourseThemesApi(root?.apiClient ?? apiClient)
    makeObservable(this)
  }
}
